import React, { useState } from 'react';

import PollScreen from './screens/PollsScreen';
import PollItemScreen from './screens/PollItemScreen';
import CreatePollScreen from './screens/CreatePollScreen';
import CreateQuestionScreen from './screens/CreateQuestionScreen';
import CreateAnswerScreen from './screens/CreateAnswerScreen';

import { IShownComponents } from './express-help.types';
import QuestionItemScreen from './screens/QuestionItemScreen';

const PollComponents: React.FC = (props: any) => {
    const [shown, setShown] = useState<IShownComponents>({
        mainPageShown: true,
        pollPageShown: false,
        questionPageShown: false,
        answerPageShown: false,
        pollItemPageShown: false,
        editMode: false,
    });

    const showPage = (page: IShownComponents) => {
        if (page && page.mainPageShown) {
            setShown({
                mainPageShown: true,
                pollPageShown: false,
                pollItemPageShown: false,
                questionPageShown: false,
                answerPageShown: false,
                questionsAnswersPageShown: false,
                idOfQuestionnaire: page.idOfQuestionnaire,
                idOfQuestion: page.idOfQuestion,
                idOfAnswer: page.idOfAnswer,
                idOfResult: page.idOfResult,
                idOfResultType: page.idOfResultType,
                editMode: false,
            });
        }
        if (page && page.pollPageShown) {
            setShown({
                mainPageShown: false,
                pollPageShown: true,
                pollItemPageShown: false,
                questionPageShown: false,
                answerPageShown: false,
                questionsAnswersPageShown: false,
                idOfQuestionnaire: page.idOfQuestionnaire,
                idOfQuestion: page.idOfQuestion,
                idOfAnswer: page.idOfAnswer,
                idOfResult: page.idOfResult,
                idOfResultType: page.idOfResultType,
                editMode: false,
            });
        }
        if (page && page.questionPageShown) {
            setShown({
                mainPageShown: false,
                pollPageShown: false,
                pollItemPageShown: false,
                questionPageShown: true,
                answerPageShown: false,
                questionsAnswersPageShown: false,
                idOfQuestionnaire: page.idOfQuestionnaire,
                idOfQuestion: page.idOfQuestion,
                idOfAnswer: page.idOfAnswer,
                idOfResult: page.idOfResult,
                idOfResultType: page.idOfResultType,
                editMode: false,
            });
        }
        if (page && page.answerPageShown) {
            setShown({
                mainPageShown: false,
                pollPageShown: false,
                pollItemPageShown: false,
                questionPageShown: false,
                answerPageShown: true,
                questionsAnswersPageShown: false,
                idOfQuestionnaire: page.idOfQuestionnaire,
                idOfQuestion: page.idOfQuestion,
                idOfAnswer: page.idOfAnswer,
                idOfResult: page.idOfResult,
                idOfResultType: page.idOfResultType,
                editMode: false,
            });
        }
        if (page && page.pollItemPageShown) {
            setShown({
                mainPageShown: false,
                pollPageShown: false,
                pollItemPageShown: true,
                questionPageShown: false,
                answerPageShown: false,
                questionsAnswersPageShown: false,
                idOfQuestionnaire: page.idOfQuestionnaire,
                idOfQuestion: page.idOfQuestion,
                idOfAnswer: page.idOfAnswer,
                idOfResult: page.idOfResult,
                idOfResultType: page.idOfResultType,
                editMode: true,
            });
        }
        if (page && page.questionsAnswersPageShown) {
            setShown({
                mainPageShown: false,
                pollPageShown: false,
                pollItemPageShown: false,
                questionPageShown: false,
                answerPageShown: false,
                questionsAnswersPageShown: true,
                idOfQuestionnaire: page.idOfQuestionnaire,
                idOfQuestion: page.idOfQuestion,
                idOfAnswer: page.idOfAnswer,
                idOfResult: page.idOfResult,
                idOfResultType: page.idOfResultType,
                editMode: true,
            });
        }
    };

    return (
        <div>
            {shown.mainPageShown && (
                <PollScreen
                    user={props.user}
                    showNext={showPage}
                    showObject={shown}
                />
            )}
            {shown.pollPageShown && (
                <CreatePollScreen
                    user={props.user}
                    showNext={showPage}
                    showObject={shown}
                />
            )}
            {shown.questionPageShown && (
                <CreateQuestionScreen
                    user={props.user}
                    showNext={showPage}
                    showObject={shown}
                />
            )}
            {shown.questionsAnswersPageShown && (
                <QuestionItemScreen
                    user={props.user}
                    showNext={showPage}
                    showObject={shown}
                />
            )}
            {shown.answerPageShown && (
                <CreateAnswerScreen
                    user={props.user}
                    showNext={showPage}
                    showObject={shown}
                />
            )}
            {shown.pollItemPageShown && (
                <PollItemScreen
                    user={props.user}
                    showNext={showPage}
                    showObject={shown}
                />
            )}
        </div>
    );
};

export default PollComponents;
